import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { fetchCount } from './counterAPI';
import moment from "moment";
const initialState = {
  user_id: "",
  fmc_id: "",
  amm_fmc_id: "",
  amm_fmc_uuid: "",
  user_name: "",
  first_name: "",
  last_name: "",
  email: "",
  roleClaims: [],
  role_ids: [],
  roles: [],
  token: "",
  refresh_token: "",
  resetPw_code: "",
  permissions: {
    hasCreate: false,
    hasDelete: false,
    hasRead: false,
    hasReview: false,
    hasUpdate: false,
    hasVerify: false,
    hasViewAllIncidents: false,
    hasViewReviewedIncidents: false,
    hasViewVerifiedIncidents: false,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateToken(state, action) {
      const { refresh_token, access_token, expiry_time } = action.payload;
      state.refresh_token = refresh_token;
      state.token = access_token;
      state.expiry_time = expiry_time;
      state.inactivity_timeout = Math.ceil(
        moment(expiry_time).utc().diff(moment.utc(), "seconds", true)
      );
    },

    clearUser(state) {
      // state = initialState
      state.user_id = "";
      state.token = "";
      state.refresh_token = "";
      state.expiry_time = "";
      state.email = "";
      state.user_name = "";
      state.first_name = "";
      state.last_name = "";
      state.name = "";
      state.roleClaims = [];
      state.role_ids = [];
      state.roles = [];
    },

    updateUserDetails(state, action) {
      const {
        user_id,
        fmc_id,
        amm_fmc_id,
        amm_fmc_uuid,
        user_name,
        first_name,
        last_name,
        email,
      } = action.payload;
      state.user_id = user_id || "";
      state.fmc_id = fmc_id || "";
      state.amm_fmc_id = amm_fmc_id || "";
      state.amm_fmc_uuid = amm_fmc_uuid || "";
      state.user_name = user_name || "";
      state.first_name = first_name;
      state.last_name = last_name;
      state.name = first_name + " " + last_name;
      state.email = email || "";
    },
    updateUserPermissions(state, action) {
      const {
        hasCreate,
        hasDelete,
        hasRead,
        hasReview,
        hasUpdate,
        hasVerify,
        hasViewAllIncidents,
        hasViewReviewedIncidents,
        hasViewVerifiedIncidents,
      } = action.payload;
      state.permissions.hasCreate = hasCreate;
      state.permissions.hasDelete = hasDelete;
      state.permissions.hasRead = hasRead;
      state.permissions.hasReview = hasReview;
      state.permissions.hasUpdate = hasUpdate;
      state.permissions.hasVerify = hasVerify;
      state.permissions.hasViewAllIncidents = hasViewAllIncidents;
      state.permissions.hasViewReviewedIncidents = hasViewReviewedIncidents;
      state.permissions.hasViewVerifiedIncidents = hasViewVerifiedIncidents;
    },
    updateRolesAndRoleClaims(state, action) {
      var _roleClaims = [];
      var _role_ids = [];
      var _roles = [];
      action.payload.map((item) => {
        _role_ids.push(item.role_id);
        _roles.push({
          role_id: item.role_id,
          name: item.name,
          desc: item.desc,
          app_code: item.app_code,
        });

        item.role_claims.map((claim) => {
          _roleClaims.push(claim.claim_value);
        });
      });

      state.role_ids = _role_ids;
      state.roles = _roles;
      state.roleClaims = _roleClaims;
    },

    updateResetPasswordCode(state, action) {
      const { resetPw_code } = action.payload;
      state.resetPw_code = resetPw_code;
    },
  },
});

export const {
  updateToken,
  clearUser,
  updateUserDetails,
  updateRolesAndRoleClaims,
  updateUserPermissions,
  updateResetPasswordCode,
} = userSlice.actions;

export default userSlice.reducer;
